import { LitWeather } from './src/LitWeather.js';
export { LitWeather } from './src/LitWeather.js';
window.customElements.define('lit-weather', LitWeather);
//# sourceMappingURL=lit-weather.js.map